export default __webpack_public_path__ + "static/media/hailoffuriousstrikes4.f3a7093f.png";